import React from 'react'
import { AiOutlineMail } from 'react-icons/ai'
import { FaFacebook, FaInstagram, FaSms, FaSnapchat } from 'react-icons/fa'
import { GrLinkedin } from 'react-icons/gr'
import { ImDownload,  ImTelegram } from 'react-icons/im'
import { IoLogoTiktok } from 'react-icons/io5'
import { SiSignal, SiWhatsapp } from 'react-icons/si'
import './sass/social_gallery.scss'
const SocialGallery = () => {
    return (<>
            <div className="vh-100 bg-body">
                    <header>
                        <h2 className="p-3 text-center text-white bg-glass">Header</h2>
                    </header>
                    <main className="container h-75">
                        <div className="my-auto row h-100">
                            <div className="my-auto col-md-6">
                                <div className="p-3 border shadow hero-copy radius-15 bg-glass">
                                    <h1 className="mt-0 text-white hero-title">Landing template for startups</h1>
                                    <p className="text-white hero-paragraph">Our landing page template works on all devices, so you only have to set it up once, and get beautiful results forever.</p>
                                    <div className="social-icon d-flex justify-content-between">
                                        <FaSms size={30} color={"#CEA252"} />
                                        <AiOutlineMail size={30} color={"#CEA252"} />
                                        <FaFacebook size={30} color={"#CEA252"} />
                                        {/* <FaInstagram size={30} color={"#CEA252"} /> */}
                                        <FaSnapchat size={30} color={"#CEA252"} />
                                        <IoLogoTiktok size={30} color={"#CEA252"} />
                                        <ImTelegram size={30} color={"#CEA252"} />
                                        <SiSignal size={30} color={"#CEA252"} />
                                        <GrLinkedin size={30} color={"#CEA252"} />
                                        <SiWhatsapp size={30} color={"#CEA252"} />
                                        <ImDownload size={30} color={"#CEA252"} />
                                    </div>             
                                </div>
                            </div>
                            <div className="col-md-6">

                            </div>
                        </div>
                    </main>
                    <footer className="fixed-bottom">
                        <p className="p-2 mb-0 text-center text-white bg-glass">Gallery event &copy; 2021</p>
                    </footer>
            </div>
        </>
    )
}

export default SocialGallery
